module.exports = __webpack_public_path__ + "img/pip.943a5091.svg";